export interface IntegrationLogListParams {
  vendor_id?: string
  operation?: string
  status?: string
  success?: boolean
  limit?: number
  offset?: number
}

export interface IntegrationLog {
  id: number | string
  provider: string
  operation: string
  entity_id?: string | null
  success: boolean
  status?: string | null
  external_reference?: string | null
  created_at?: string
  logs?: {
    error_message?: string
    attempted_at?: string
    customer_sync_logs?: {
      sync_status?: string
      customer_data?: {
        customerCard?: { Name?: string }
      }
    }
  }
}

export interface IntegrationLogListResponse {
  logs: IntegrationLog[]
  count: number
}

class IntegrationLogs {
  private client: unknown

  /**
   * @ignore
   */
  constructor(client: unknown) {
    this.client = client
  }

  async list(
    queryParams?: IntegrationLogListParams
  ): Promise<IntegrationLogListResponse> {
    return (this.client as any).fetch(`/admin/vendor/integration-logs`, {
      query: queryParams,
    })
  }

  retry(id: string): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/vendor/integration-logs/${id}/retry`,
        {
          method: "POST",
        }
      )
    })()
  }
}

export { IntegrationLogs }
